import React, { FC } from 'react'
import 'components/Footer/Footer.scss'
import { Logo } from 'components/index'
const currentYear = new Date().getFullYear()
const Footer: FC = () => {
  const title = window.location.pathname.indexOf('/globalhub') !== -1 ? 'Global Hub' : 'Storybox'
  return (
    <div className="global-footer">
      <div className="global-footer__logo">
        <Logo isLoading={false} />
      </div>
      <div className="global-footer__content">
        <h5 className="global-footer__project">{title}</h5>
        <div className="global-footer__name">
          <a href="https://www.wmg.com/" className="global-footer__link">
            WARNER MUSIC GROUP
          </a>
        </div>
        <div className="global-footer__copyright">Copyright @{currentYear} Warner Music Inc.</div>
        <div className="global-footer__links">
          <a href="https://www.wmg.com/who-we-are" className="global-footer__link">
            About Warner Music Group |
          </a>
          <a href="https://www.wmg.com/faq" className="global-footer__link">
            &nbsp;Help & FAQs |
          </a>
          <a href="https://www.wmg.com/privacy-policy" className="global-footer__link">
            &nbsp;Privacy Policy |
          </a>
          <a href="https://www.wmg.com/terms-of-use" className="global-footer__link">
            &nbsp;Terms & Conditions
          </a>
        </div>
      </div>
    </div>
  )
}

export default Footer
